"use client";

import { useStore } from "@/hooks/system/useStore";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

const AddressesProvider = () => {
  const { setMap } = useStore("addresses");
  const map = useMap();

  useEffect(() => {
    setMap(map);
    return () => {
      setMap(null);
    };
  }, [map, setMap]);

  return null;
};

export default observer(AddressesProvider);
